const updates = [
  { date: '07.30', title: '红桃视频「夏日特别篇」今日上线', type: '上新' },
  { date: '07.29', title: '小蓝视频经典合集高清修复版发布', type: '修复' },
  { date: '07.28', title: '黑桃视频最新连载第48话已更新', type: '更新' },
  { date: '07.27', title: '91视频风格专题「都市夜话」开设', type: '专题' },
  { date: '07.26', title: '97视频4K片源本周新增120+部', type: '扩充' },
  { date: '07.25', title: '久久视频周末限免活动开启', type: '活动' },
  { date: '07.24', title: '梅花视频精选推荐榜单全新改版', type: '改版' },
  { date: '07.23', title: '白桃视频每日更新量突破200部', type: '里程碑' },
  { date: '07.22', title: '绿萝视频全新频道首页正式上线', type: '上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Latest Updates</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">最新动态</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频数字颜色系列各频道实时更新资讯</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 before:absolute before:left-[13px] before:top-2 before:bottom-2 before:w-[2px] before:bg-gradient-to-b before:from-primary-500/40 before:via-accent-500/20 before:to-transparent">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-7 md:pb-8 last:pb-0">
                <div className="absolute left-[-34px] md:left-[-42px] top-1 w-[22px] h-[22px] md:w-[26px] md:h-[26px] flex items-center justify-center rounded-full bg-background-800 border-2 border-primary-500/30 z-10">
                  <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                  <span className="text-xs font-medium text-primary-400 bg-primary-500/10 px-2 py-0.5 rounded whitespace-nowrap w-fit">{item.date}</span>
                  <span className="text-xs font-medium text-accent-400 bg-accent-500/10 px-2 py-0.5 rounded whitespace-nowrap w-fit">{item.type}</span>
                  <h3 className="text-sm md:text-base text-foreground-200 font-medium flex-1">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}